import { createIconComponent } from '../../factory/create-icon-component';
export const ReorderIcon = createIconComponent(
  'ReorderIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="2"
      y="2"
      width="20"
      height="20"
      rx="5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 12C6 15.3137 8.68629 18 12 18C15.3137 18 17.5 15 17.5 15M18 12C18 8.68629 15.3333 6 12 6C8 6 6.5 9 6.5 9M6.5 9V6.5M6.5 9H9M17.5 15H15M17.5 15V17.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
